import decode from 'jwt-decode';
import { storageHandler } from './storageHandler';
export const decodeToken = (token) => {
    if (token) {
        try {
            return decode(token);
        }
        catch (e) {
            // logger.error(e);
        }
    }
    return null;
};
const getTokenExpirationDate = (token) => {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) {
        return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
};
export const isTokenExpired = (token) => {
    const date = getTokenExpirationDate(token);
    return date !== null ? !(date.valueOf() > new Date().valueOf()) : true;
};
export const getUserDetails = (browserCacheType = 'localStorage') => {
    try {
        const storedToken = storageHandler(browserCacheType).getAuthToken();
        const decoded = decodeToken(storedToken || '');
        if (decoded) {
            const { email, name } = decoded;
            return { email, name };
        }
        return { email: '', name: '' };
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return { email: '', name: '' };
};
export const validateToken = (browserCacheType = 'localStorage') => {
    const existingToken = storageHandler(browserCacheType).getAuthToken();
    if (existingToken && !isTokenExpired(existingToken)) {
        return true;
    }
    storageHandler(browserCacheType).clean();
    return false;
};
//# sourceMappingURL=token.js.map